module.exports = __webpack_public_path__ + "images/emoji/cloud.8fdb1e8c528b25cd3087.png";